import {
  FormLabel,
  FormLabelProps,
  Typography,
  styled,
  useTheme,
} from '@mui/material';
import { typographyCss } from 'theme/typography-css';

export const FormLabelStyled = styled(
  ({ children, ...props }: FormLabelProps) => {
    const theme = useTheme();
    return (
      <FormLabel {...props}>
        <Typography
          sx={{
            ...typographyCss(theme, 'body2'),
            fontSize: '.75rem',
            fontWeight: 700,
          }}
        >
          {children}
        </Typography>
      </FormLabel>
    );
  },
)(() => ({
  marginTop: 9,
}));
